export const featuredRoutesDisplayLimit = 1;